module.exports = __webpack_public_path__ + "static/media/screenshot3.5187bf85.png";